/**
 * @generated SignedSource<<da8d7583039e70d6f856a2881c88fb92>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "orderId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "orderId",
        "variableName": "orderId"
      }
    ],
    "concreteType": "Order",
    "kind": "LinkedField",
    "name": "UserRetrievedOrder",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "statusName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "allowedCustomerActions",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "primeCustomerAction",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CoverDeliveryModalMutation",
    "selections": (v1/*: any*/),
    "type": "ClientAppMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CoverDeliveryModalMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b2f85e2f9ba7ebb87fc35ef143b8ef89",
    "id": null,
    "metadata": {},
    "name": "CoverDeliveryModalMutation",
    "operationKind": "mutation",
    "text": "mutation CoverDeliveryModalMutation(\n  $orderId: Int!\n) {\n  UserRetrievedOrder(orderId: $orderId) {\n    id\n    status\n    statusName\n    allowedCustomerActions\n    primeCustomerAction\n  }\n}\n"
  }
};
})();

node.hash = "6d027f3d5fc657b8c856ad9275be2cc2";

module.exports = node;
